import { faXmark } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";
import React, { useEffect } from "react";

import IconButton from "../Header/IconButton";
import InputBox from "../InputBox/InputBox";

type MaskProps = {
  isOpen: boolean;
  onClose: () => void;
  searchValue?: string;
  onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchSubmit?: (value: string) => void;
  className?: string;
};

/**
 * Mask component integrated with InputBox for full-screen search as per Figma design.
 */
export default function Mask({
  isOpen,
  onClose,
  searchValue,
  onSearchChange,
  onSearchSubmit,
  className,
}: MaskProps) {
  // Lock body scroll when mask is open
  useEffect(() => {
    if (isOpen) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      data-testid="mask-overlay"
      className={clsx(
        "bg-background-secondary animate-fade-in fixed inset-0 z-50 flex flex-col",
        className,
      )}
    >
      <div className="animate-fade-in-up flex flex-1 flex-col items-center justify-center">
        <div className="w-full max-w-[560px] px-3 lg:max-w-[800px]">
          <InputBox
            variant="search"
            showSearchLabel
            placeholder="Enter keywords to search"
            value={searchValue}
            onChange={onSearchChange}
            onSubmit={onSearchSubmit}
          />
        </div>
      </div>

      <div className="animate-fade-in absolute top-0 right-0 z-10 p-3 lg:p-4">
        <IconButton
          icon={faXmark}
          onClick={onClose}
          ariaLabel="Close"
          className="hover:bg-button-ghost-hover"
        />
      </div>
    </div>
  );
}
